import { EUROPACE_PROCESS_PLATFORMS } from 'cpool-constants';
import type { EUROPACE_PROCESS_PLATFORM, UserState } from 'cpool-constants';

export const getMatchingEuropacePlatformPartnerId = (
    platform: EUROPACE_PROCESS_PLATFORM | null,
    user: UserState['user'],
) => {
    if (!user?.europacePlatforms) {
        return { partnerId: null, platform };
    }
    // If the platform is not provided, we need to check if the user has a partner id for either platform
    // This is used when the user is importing a process and we need to know which partner id to use
    // Current Order is
    // 1. Starpool
    // 2. Europace2
    if (!platform) {
        if (user.europacePlatforms.starpool.partnerId) {
            return {
                partnerId: user.europacePlatforms.starpool.partnerId,
                platform: EUROPACE_PROCESS_PLATFORMS.STARPOOL,
            };
        }
        if (user.europacePlatforms.europace2.partnerId) {
            return {
                partnerId: user.europacePlatforms.europace2.partnerId,
                platform: EUROPACE_PROCESS_PLATFORMS.EUROPACE2,
            };
        }
        return { partnerId: null, platform };
    }

    // If the platform is provided, we can return the partner id for the corresponding platform
    switch (platform) {
        case EUROPACE_PROCESS_PLATFORMS.EUROPACE2:
            return {
                partnerId: user.europacePlatforms.europace2.partnerId,
                platform,
            };
        case EUROPACE_PROCESS_PLATFORMS.STARPOOL:
            return {
                partnerId: user.europacePlatforms.starpool.partnerId,
                platform,
            };
        default:
            return { partnerId: null, platform };
    }
};
